import React from 'react';
import { EmptyStateHorizontalTemplate } from 'themes/components';

function EmptyStateHorizontal(props) {
    return <EmptyStateHorizontalTemplate {...props} />
}

export default EmptyStateHorizontal;